<template>
  <div>
    <div v-if="row.info">
      {{ row.info.closed_route ? 'Да' : 'Нет' }}
    </div>
  </div>
</template>

<script>
export default {
  name: "close-route-column-template",
  components: {},
  props: {
    row: {type: Object, required: true}
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style>

</style>